import { EpimsBaseEntityDto } from './epim-base.dto';

export class EncroachmentAssetDto extends EpimsBaseEntityDto {
  EncroachmentAssetId: string;
  EncroachmentTypeId: string;
  // public virtual EncroachmentType EncroachmentType :string;
  AssetSerialNo: string;
  PipelineEncroachmentId: string;
  EncroachmentAssetName: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  Remarks: string;
  EncroachmentStatusId: string;
  EncroachmentDate: Date;
  Description: string;
  Recommendation: string;
}
